import { Enjoy } from './Enjoy'
import { General } from './General'
import { Noise } from './Noise'
import { Statistics } from './Statistics'

export const Component = { Noise, General, Statistics, Enjoy }
